<!-- Чаты -->
<template>
  <li
    v-if="canSeePage('chats')"
    class="nav-item chat-nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Chats')"
    @mouseup="handleMiddleClick($event, 'Chats')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Chats')"
    :class="{ active: activeItem === 'chats' }"
    :title="collapsed ? 'Чаты' : ''"
  >
    <div class="link-icon_box">
      <AppIcon
        name="comment"
        :size="24"
        stroke="#00bfa5"
      />
      <span
        v-if="unreadCount > 0 && collapsed"
        class="chat-nav-badge chat-nav-badge--icon"
      >
        {{ unreadCountLabel }}
      </span>
    </div>
    <AppSidebarItemLabel
      label="Чаты"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
    <span
      v-if="unreadCount > 0 && !collapsed"
      class="chat-nav-badge"
    >
      {{ unreadCountLabel }}
    </span>
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import AppIcon from "@/components/Icon/AppIcon.vue";
import { sidebarItemProps } from "@/composables/useSidebarItem";
import { unreadCountBadgeLabel } from "@/utils/chatUnreadUtils";

export default {
  name: "ChatsItem",
  components: {
    AppSidebarItemLabel,
    AppIcon,
  },
  props: {
    ...sidebarItemProps,
    unreadCount: {
      type: Number,
      default: 0,
    },
  },
  emits: ["navigate", "middle-click", "context-menu"],
  computed: {
    unreadCountLabel() {
      return unreadCountBadgeLabel(this.unreadCount);
    },
  },
  methods: {
    navigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    handleMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    showContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>

<style scoped>
.link-icon_box {
  position: relative;
}

.chat-nav-item {
  overflow: visible;
}

.chat-nav-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  margin-left: auto;
  margin-right: 10px;
  padding: 0 6px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  box-sizing: border-box;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  flex-shrink: 0;
}

.chat-nav-badge--icon {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 16px;
  height: 16px;
  margin-left: 0;
  margin-right: 0;
  padding: 0 4px;
  font-size: 9px;
}
</style>
